import React from 'react';
import { useCart } from '../context/CartContext';
export function Women() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-842">
      <div className="max-w-[1800px] mx-auto" data-id="element-843">
        <header className="mb-20 text-center" data-id="element-844">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-845">
            Feminine Heritage
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-846">
            Women
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-847">
            Graceful silhouettes and intricate patterns designed for the modern
            woman.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-848">
          {['https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png', 'https://cdn.magicpatterns.com/uploads/pyPQ371b8FAGqP4T9JAg1g/image.png', 'https://cdn.magicpatterns.com/uploads/d353YWp21zZqnC3Pek7CAu/image.png'].map((img, i) => <div key={i} className="group" data-id="element-849">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-6 relative" data-id="element-850">
                <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Womenswear" data-id="element-851" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-852">
                  <button onClick={() => addToCart({
                id: `women-${i}`,
                name: `Womenswear Look ${i + 1}`,
                price: '$320.00',
                image: img,
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-853">
                    Add to Bag
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-start" data-id="element-854">
                <div data-id="element-855">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-856">
                    Womenswear Look {i + 1}
                  </h3>
                  <p className="text-sm font-light text-black/50" data-id="element-857">$320.00</p>
                </div>
                <button onClick={() => addToCart({
              id: `women-${i}`,
              name: `Womenswear Look ${i + 1}`,
              price: '$320.00',
              image: img,
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-858">
                  Add to Bag
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}